  import A11yDialog from 'https://cdn.jsdelivr.net/npm/a11y-dialog@8/dist/a11y-dialog.esm.min.js'

document.addEventListener("DOMContentLoaded", () => {
  console.log("alive")

// Select all team members
const teamMembers = document.querySelectorAll('.team-text-image');


// Function to create modals
function createModal(teamMember) {

   const id = teamMember.dataset.id;
   
  const name = teamMember.dataset.name;
  const role = teamMember.dataset.role;
  const imgSrc = teamMember.querySelector('img').src;


  // Initialize A11y Dialog
  const dialogElement = document.getElementById(`team-member-${id}`);
  const dialogInstance = new A11yDialog(dialogElement);
  dialogInstance
  .on('show', () => (document.documentElement.style.overflowY = 'hidden'))
  .on('hide', () => (document.documentElement.style.overflowY = ''))

  // Add event listener to open the modal when the team member is clicked
  teamMember.addEventListener('click', () => {
    dialogInstance.show();
  
  });
}

// Generate a modal for each team member
teamMembers.forEach(createModal);
})